import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FilterAutoOpenService {
    private toOpen = new Set();

    constructor() {}

    isAutoOpen(id: string) {
        return this.toOpen.has(id);
    }

    markToOpen(id: string) {
        this.toOpen.add(id);
    }

    opened(id: string) {
        this.toOpen.delete(id);
    }
}
